<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl-2">
  <div class="form-horizontal">
    <div class="row">
      <div class="col-md-12">
        <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist 
              [ModelName]="'vrstastavki'" 
              [GetName]="'get'" 
              [ModelProperty]="'Naziv'" 
              [OrderBy]="'Naziv'"
              [AllowAddNew]="false" 
              formControlName="VrstaStavkiId" 
              [Label]="'VRSTASTAVKIKODKUPCA.VRSTASTAVKI.SINGULAR'"
              (OnItemSelected)="onVrstaStavkiSelected($event)"
              [ngClass]="{'is-invalid': submitted && fc.VrstaStavkiId.invalid}">
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.VrstaStavkiId.invalid">
              <span *ngFor="let validation of errorMessages.VrstaStavkiId">
                <span class="error-message" *ngIf="fc.VrstaStavkiId.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>      
          </div>
        </div>
      <div class="form-group row">
          <div class="col-md-12">
            <yt-dropdown-picklist 
              [ModelName]="'komitent'" 
              [GetName]="'get'" 
              [ModelProperty]="'Naziv'"
              [OrderBy]="'Naziv'" 
              formControlName="KomitentId" 
              [Label]="'VRSTASTAVKIKODKUPCA.KOMITENT.SINGULAR'"
              [ngClass]="{'is-invalid': submitted && fc.KomitentId.invalid}">
            </yt-dropdown-picklist>
            <div class="form-error" *ngIf="submitted && fc.KomitentId.invalid">
              <span *ngFor="let validation of errorMessages.KomitentId">
                <span class="error-message" *ngIf="fc.KomitentId.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12">
            <yt-input 
              [Type]="'text'" 
              name="txtSifraKodKomitenta" 
              formControlName="SifraKodKomitenta" 
              [MaxLength]="13" 
              [Label]="'VRSTASTAVKIKODKUPCA.SIFRAKODKOMITENTA.SINGULAR'"
              [ngClass]="{'is-invalid': submitted && fc.SifraKodKomitenta.invalid}">
            </yt-input>
            <div class="form-error" *ngIf="submitted && fc.SifraKodKomitenta.invalid">
              <span *ngFor="let validation of errorMessages.SifraKodKomitenta">
                <span class="error-message" *ngIf="fc.SifraKodKomitenta.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
              </span>
            </div>
          </div>
        </div>
    </div>
  </div>
  </div>
</form>